const koreanCharCode = {
  start: '가'.charCodeAt(0),
  end: '힣'.charCodeAt(0),
  jongSeongStart: 28,
} as const;

const REG_SPECIAL_CHAR = new RegExp(
  `(?:${[
    '[ㄱ-ㄷㅁ-ㅎ036]',
    '^[mn]',
    '\\S[mn]e?',
    '\\S(?:[aeiom]|lu)b',
    '(?:u|\\S[aei]|[^o]o)p',
    '(?:[^auh]i|\\Su|[^ei][ae]|[^oi]o)t',
    '(?:\\S[iou]|[^e][ae])c?k',
    '\\S[aeiou](?:c|ng)',
    'foot|go+d|b[ai]g|private',
    '^(?:app|kor)',
  ].join('|')})$`,
  'i',
);

type Josa =
  | '고'
  | '이고'
  | '나'
  | '이나'
  | '네'
  | '이네'
  | '다'
  | '이다'
  | '라'
  | '이라'
  | '면'
  | '이면'
  | '이지'
  | '지'
  | '로'
  | '으로'
  | '이'
  | '가'
  | '과'
  | '와'
  | '을'
  | '를'
  | '은'
  | '는'
  | '이에요'
  | '예요';

type JosaTable = {
  reg: RegExp;
  map: [string, string];
  mapper?: (jongseong: number) => number;
};

const josaTable: JosaTable[] = [
  { reg: /^(을|를)$/, map: ['를', '을'] },
  { reg: /^(이|가)$/, map: ['가', '이'] },
  { reg: /^(은|는)$/, map: ['는', '은'] },
  { reg: /^(이에요|예요)$/, map: ['예요', '이에요'] },
  { reg: /^(과|와)$/, map: ['와', '과'] },
  {
    reg: /^(으?로)$/,
    map: ['로', '으로'],
    mapper: (jongseong: number) => {
      const noJongseong = jongseong === 0;

      if (noJongseong) {
        return 0;
      }

      const isLieul = jongseong === 8;

      if (isLieul) {
        return 0;
      }

      return 1;
    },
  },
  { reg: /^(이?)([고나네다라면지])$/, map: ['$2', '이$2'] },
];

const checkJosaTable = (josa: Josa, jongseong: number) => {
  const item = josaTable.find((x) => x.reg.test(josa));

  if (item == null) {
    return undefined;
  }

  const { reg, map, mapper } = item;

  return josa.replace(
    reg,
    map[(mapper?.(jongseong) ?? jongseong) !== 0 ? 1 : 0],
  );
};

export const getJosa = (text = '', josa: Josa, as: string = text) => {
  if (as == null || as === '') {
    return '';
  }

  const code = as.charCodeAt(as.length - 1);

  if (code < koreanCharCode.start || code > koreanCharCode.end) {
    const hasJongseong = REG_SPECIAL_CHAR.test(text);

    return checkJosaTable(josa, hasJongseong ? -1 : 0);
  }

  const jongseong = (code - 0xac00) % 28;

  return checkJosaTable(josa, jongseong);
};

export const addJosa = (text = '', josa: Josa, as: string = text) => {
  if (as == null || as === '') {
    return '';
  }

  return text + getJosa(text, josa, as);
};
